import { render, staticRenderFns } from "./bookmark-checkbox.vue?vue&type=template&id=d01ab00a&scoped=true&"
import script from "./bookmark-checkbox.vue?vue&type=script&lang=ts&"
export * from "./bookmark-checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./bookmark-checkbox.vue?vue&type=style&index=0&id=d01ab00a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01ab00a",
  null
  
)

export default component.exports